export default __webpack_public_path__ + "static/media/RIASEC_Compass_v3.afbee53d.png";